import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ac6039154ab17770fdc2ad1e0121fa1a1b from "./generated-11c66419-49df-4a75-9f29-fccd83af894b.json";

import a18b3f9793764d71b231cac68ab196df6b from "./generated-59810774-0ebf-4b0c-bc51-ec88f3372609.json";

import a3a41a5bfd97dcc33722ae29a8675a868b from "./generated-cca0270b-2888-4401-9492-173eeb5f29c6.json";

import abacfcfbfa530a98723ef0deae5842d95b from "./generated-fe439a21-27d8-4ee8-b9f1-ff8d9d6efee2.json";

import ae09bc08a8b85416ddf5743223c5bfb9eb from "./generated-f4c8bc84-36d5-4ecc-b0c9-94bf451b3a65.json";

import a3bc2d65c4d02220ed660f0b243216000b from "./generated-e8162dc6-7405-405e-9b52-3ce560e7227f.json";

import a2c4b765261b40b5bbc30cf8803f13390b from "./generated-7fbc3421-d9cf-4b51-87ab-e6cec4fc2ea8.json";

import a678f84857477a80d990b145a6e87135cb from "./generated-3313804d-c9ac-4ba5-87ed-cac6e552472c.json";

import a058be83f17a92ec1302130e9ad34d719b from "./generated-feafaa4c-419a-473f-b326-4db44aac36df.json";

import aaef382defcbc8826bb32c07753c13852b from "./generated-d9d77efe-7b69-4eeb-b044-c9b7b67e9915.json";

import a20536c6f6714936e0fc116ad2efa2ce8b from "./generated-ac65825c-93be-4348-9e9a-000063d23567.json";

import aa84b529b8c2bde4fad7c34d60443b00fb from "./generated-cedcad62-19b7-4933-8f86-4fe8642a0651.json";

import a4f734bbe0cb7d49cccd4c75666c813f5b from "./generated-70644586-dcf5-4f05-9974-a82350a7e204.json";

import a6ec313a10465d7b19b98e35a25af493db from "./generated-f24ae3c5-7104-4753-8c73-368812265723.json";

import a96da8a82e5e31eed2c0ada4d7ecc1fddb from "./generated-7e086df1-7bfe-4b5e-a2b2-f920c64abad8.json";

import a7a041719f3b7547eaba3f51688a7b05fb from "./generated-34acdc74-5666-40e4-8d44-322baaa39731.json";

import a4b415a0699dbdc05182527bfed884417b from "./generated-af963960-6533-41a6-9c57-7ed728324200.json";

import a8a7a3f28602d81e1f032de68e7ecae01b from "./generated-2a28247c-05d7-44e0-a5f4-7ab6f615d323.json";

import a784eabc1519501d6156cd48051456615b from "./generated-f8b662eb-a42d-4a23-a390-0a0478cf5b0d.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ac6039154ab17770fdc2ad1e0121fa1a1b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a18b3f9793764d71b231cac68ab196df6b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a3a41a5bfd97dcc33722ae29a8675a868b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(abacfcfbfa530a98723ef0deae5842d95b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ae09bc08a8b85416ddf5743223c5bfb9eb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a3bc2d65c4d02220ed660f0b243216000b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a2c4b765261b40b5bbc30cf8803f13390b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a678f84857477a80d990b145a6e87135cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a058be83f17a92ec1302130e9ad34d719b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aaef382defcbc8826bb32c07753c13852b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a20536c6f6714936e0fc116ad2efa2ce8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(aa84b529b8c2bde4fad7c34d60443b00fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a4f734bbe0cb7d49cccd4c75666c813f5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a6ec313a10465d7b19b98e35a25af493db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a96da8a82e5e31eed2c0ada4d7ecc1fddb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a7a041719f3b7547eaba3f51688a7b05fb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a4b415a0699dbdc05182527bfed884417b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a8a7a3f28602d81e1f032de68e7ecae01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a784eabc1519501d6156cd48051456615b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a4b415a0699dbdc05182527bfed884417b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */